import { render, staticRenderFns } from "./additional-info.vue?vue&type=template&id=f6a83fa4&scoped=true&"
import script from "./additional-info.vue?vue&type=script&lang=js&"
export * from "./additional-info.vue?vue&type=script&lang=js&"
import style0 from "./additional-info.vue?vue&type=style&index=0&id=f6a83fa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a83fa4",
  null
  
)

export default component.exports